export const CATEGORY_LOADING = 'CATEGORY_LOADING'
export const GET_CATEGORY = 'GET_CATEGORY'
export const CLEAR_CATEGORY = 'CLEAR_CATEGORY'
